var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout-padding", attrs: { id: "user-billing" } },
    [
      _c(
        "h5",
        [
          _c("q-icon", { attrs: { name: "attach_money", color: "primary" } }),
          _vm._v(" Billing ")
        ],
        1
      ),
      _c("div", { staticClass: "row" }, [
        _c("h6", { staticClass: "q-pa-md" }, [_vm._v("Payment Methods")]),
        _vm.paymentProfiles.length == 0
          ? _c("div", { staticClass: "col-12 q-pa-md" }, [
              _vm._v("\n      No payment profiles found.\n    ")
            ])
          : _vm._e(),
        _vm.paymentProfiles.length > 0
          ? _c(
              "div",
              { staticClass: "col-12 q-pa-md" },
              [
                _c(
                  "q-list",
                  {
                    staticClass: "round",
                    attrs: { separator: "", highlight: "" }
                  },
                  _vm._l(_vm.paymentProfiles, function(paymentProfile, i) {
                    return _c(
                      "q-item",
                      { key: i },
                      [
                        _c(
                          "q-item-main",
                          [
                            _c("q-icon", { attrs: { name: "credit_card" } }),
                            _vm._v(
                              " " +
                                _vm._s(paymentProfile.label) +
                                "\n          "
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item-side",
                          { attrs: { right: "" } },
                          [
                            _c("q-btn", {
                              attrs: {
                                icon: "fa fa-trash-o",
                                color: "red",
                                flat: ""
                              },
                              nativeOn: {
                                click: function($event) {
                                  _vm.deleteProfileMethod(paymentProfile)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                )
              ],
              1
            )
          : _vm._e(),
        _vm.user.CUSTOMER_ID
          ? _c("div", { staticClass: "col-12 q-pa-md meta" }, [
              _vm._v(
                "\n      Customer ID: " +
                  _vm._s(_vm.user.CUSTOMER_ID) +
                  "\n    "
              )
            ])
          : _vm._e()
      ]),
      _c(
        "q-inner-loading",
        { attrs: { visible: _vm.loading } },
        [
          _c("q-spinner-puff", { attrs: { color: "primary", size: "70" } }),
          _c("span", [_vm._v("Loading..")])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }